import { IRole } from "../models";

export const filterTeamRoles = (roles: IRole[]): IRole[] => {
  return roles.filter((role) => !role.teamId);
};
